import module from 'finanzas/module.js'

function CargarMovimientosBancariosService($api, $filter, $http) {
  let cargarMovimientosBancarios = this

  cargarMovimientosBancarios.formarTabla = formarTabla
  cargarMovimientosBancarios.subirMovimientos = subirMovimientos
  cargarMovimientosBancarios.getOperadoras = getOperadoras
  cargarMovimientosBancarios.tabla = tabla

  function formarTabla(data, obj_CuentaBancaria, session, anio) {
    let datosArreglados

    if (obj_CuentaBancaria.Banco === 'Bancomer') {
      datosArreglados = arreglarDatosBancomer(data, anio)
      if (datosArreglados[0].divisa) {
        datosArreglados = arreglarDatosBancomer2(data)
      }

      return tabla(datosArreglados, obj_CuentaBancaria, session)
    } else if (obj_CuentaBancaria.Banco === 'Banamex') {
      datosArreglados = arreglarDatosBanamex(data)
      let arreglo = tabla(datosArreglados, obj_CuentaBancaria, session)

      if (arreglo.length <= 0) {
        datosArreglados = arreglarDatosBanamex2(data)
        arreglo = tabla(datosArreglados, obj_CuentaBancaria, session)
      }
      return arreglo
    } else if (obj_CuentaBancaria.Banco === 'Banorte') {
      datosArreglados = arreglarDatosBanorte(data)
      return tabla(datosArreglados, obj_CuentaBancaria, session)
    } else if (obj_CuentaBancaria.Banco === 'BanBajio') {
      datosArreglados = arreglarDatosBanBanjio(data)
      return tabla(datosArreglados, obj_CuentaBancaria, session)
    } else if (obj_CuentaBancaria.Banco === 'Santander Serfin') {
      datosArreglados = arreglarDatosSantander(data)
      if (!datosArreglados)
        datosArreglados = arreglarDatosSantanderSegundo(data)
      return tabla(datosArreglados, obj_CuentaBancaria, session)
    } else if (obj_CuentaBancaria.Banco === 'Scotiabank') {
      datosArreglados = arreglarDatosScotiabank(data)
      return datosArreglados ? tabla(datosArreglados, obj_CuentaBancaria, session) : []
    } else if (obj_CuentaBancaria.Banco === 'BanRegio') {
      datosArreglados = arreglarDatosBanRegio(data)
      return datosArreglados ? tabla(datosArreglados, obj_CuentaBancaria, session) : []
    } else {
      return []
    }
  }

  function tabla(datosArreglados, obj_CuentaBancaria, session) {
    if (datosArreglados.length > 0) {
      try {
        return datosArreglados.map(function (item) {
          return {
            'ID_Empresa': obj_CuentaBancaria.ID_Empresa_Banco,
            // "Folio"             : ("0000000000" + ultimoFolio++).slice(-10),
            'fecha': $filter('date')(new Date(), 'yyyy-MM-dd'),
            'cuenta': obj_CuentaBancaria.Cuenta,
            'transaccion': item.transaccion,
            'cargo': item.cargo === '' ? 0.00 : convNum(item.cargo),
            'abono': item.abono === '' ? 0.00 : convNum(item.abono),
            'notas': item.notas,
            'divisa': obj_CuentaBancaria.Moneda.substr(0, 3),
            'fecha_operacion': $filter('date')(item.fechaOperacion ? item.fechaOperacion : item.fecha, 'yyyy-MM-dd'),
            'saldo': convNum(item.saldo),
            'leyenda': '000',
            'tipoOperacion': item.transaccion.search('COMISI') !== -1 ? '010' : '000',
            'nombre': session.name,
            'username': session.username,
            'ID_Empleado': obj_CuentaBancaria.ID_Empleado_Banco,
            'UID': obj_CuentaBancaria.ID_Empleado_Banco + '@' + obj_CuentaBancaria.ID_Empresa_Banco,
            'formaPago': getFormaPago(item),
            'ID_Moneda': obj_CuentaBancaria.ID_Moneda,
            'Banco': obj_CuentaBancaria.Banco,
            'ID_Banco': obj_CuentaBancaria.ID_Banco,
            'referencia': hacerReferencia(item, obj_CuentaBancaria.Banco),
            'concepto': item.concepto,
          }
        })
      } catch (e) {
        return []
      }
    } else {
      return []
    }
  }

  function getFormaPago(item) {
    return (item.transaccion.search('CHEQUE') !== -1 || item.transaccion.search('chq') !== -1 || item.transaccion.search('CHQ') !== -1 || item.notas.search('CHEQUE') !== -1) ? '02' : '01'
  }

  function hacerReferencia(item, banco) {
    let referencia, posicion
    if (banco === 'Bancomer') {
      if (item.transaccion.search('CH-') !== -1) {
        posicion = item.transaccion.indexOf('CH-')
        referencia = item.transaccion.substr(posicion + 3)
      } else {
        posicion = item.transaccion.lastIndexOf('/')
        referencia = item.transaccion.substr(posicion + 1)
        referencia = referencia.replace('IN ', '')
      }
    } else if (banco === 'Banamex') {
      if (item.transaccion.search('Autorización') !== -1) {
        posicion = item.transaccion.indexOf('Autorización')
        referencia = item.transaccion.substr(posicion + 14)
      } else {
        posicion = item.notas.indexOf('Autorización')
        referencia = item.notas.substr(posicion + 13)
      }
    } else if (banco === 'BanBajio') {
      posicion = item.notas.indexOf('Recibo # ')
      referencia = item.notas.substr(posicion + 9)
    } else if (banco === 'Banorte') {
      // referencia = item.notas
      if (item.notas.search('CHEQUE ') !== -1) {
        posicion = item.notas.indexOf('CHEQUE ')
        referencia = item.notas.substr(posicion + 7, posicion + 14)
      } else {
        posicion = item.transaccion.indexOf('CUENTA :')
        referencia = posicion !== -1 ? item.transaccion.substr(posicion + 9, posicion + 23) : ''
      }
    } else if (banco === 'Santander Serfin') {
      referencia = item.referencia
    } else if (banco === 'Scotiabank') {
      referencia = item.referencia
    } else if (banco === 'BanRegio') {
      referencia = item.referencia !== '' ? item.transaccion + ' ' + item.referencia : ''
    } else {
      referencia = banco
    }

    return referencia
  }

  function subirMovimientos(data) {
    return $api.post('/kendu/finanzas/cargaMovimientosBancario/cargarMovimientos', {
      data: data,
    })
  }

  function convNum(num) {
    num = num.replace('$', '')
    num = num.replace('-', '')
    num = num.replace(/,/g, '')
    num = parseFloat(num)
    return num
  }

  function formarFecha(fecha_old, anio) {
    let fecha = fecha_old.split('-'),
      meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      dia = ('00' + fecha[0]).slice(-2),
      mes = ('00' + (meses.indexOf(fecha[1]) + 1)).slice(-2),
      fechaaux = new Date()// fechaaux.getFullYear()

    return new Date(anio + '/' + mes + '/' + dia)
  }

  function formarFechaBanBanjio(fecha_old) {
    let fecha = fecha_old.split('-'),
      meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      dia = ('00' + fecha[0]).slice(-2),
      mes = ('00' + (meses.indexOf(fecha[1]) + 1)).slice(-2),
      anio = '20' + fecha[2]

    return new Date(anio + '/' + mes + '/' + dia)
  }

  function arreglarDatosBancomer(data, anio) {
    try {
      // Este script esta hecho solo para Bancomer
      let array = data.split('\n'),
        datos = [],
        renglon,
        indice = 0
      array.forEach(function (elemento) {
        renglon = elemento.split('\t')

        if (renglon[0] !== '') {
          datos[indice] = ({
            'fecha': formarFecha(renglon[0], anio),
            'transaccion': renglon[1],
            'cargo': renglon[2],
            'abono': renglon[3],
            'saldo': renglon[4],
            'notas': '',
            'divisa': renglon[5] ? renglon[5] : null,
          })
        } else {
          indice = indice - 1
          datos[indice].notas = renglon[1]
        }
        indice = indice + 1
      })

      return datos
    } catch (e) {
      return false
    }
  }

  function arreglarDatosBancomer2(data) {
    try {
      // Este script esta hecho solo para Bancomer
      let array = data.split('\n'),
        datos = [],
        renglon,
        indice = 0
      array.forEach(function (elemento) {
        renglon = elemento.split('\t')

        let concepto = renglon[1].split('/')[0]
        let fecha = renglon[0].split('/')
        fecha = new Date(fecha[2] + '/' + fecha[1] + '/' + fecha[0])

        if (renglon[0] !== '') {
          datos[indice] = ({
            'fecha': fecha,
            'transaccion': renglon[1],
            'cargo': renglon[2],
            'abono': renglon[3],
            'saldo': renglon[4],
            'notas': '',
            'concepto': concepto,
          })
        } else {
          indice = indice - 1
          datos[indice].notas = renglon[1]
        }
        indice = indice + 1
      })

      return datos
    } catch (e) {
      return false
    }
  }

  function arreglarDatosBanamex(data) {
    try {
      // Este script esta heco solo para Banamex
      let array = data.split('\n'),
        datos = [],
        renglon,
        fecha,
        indice = 0
      array.forEach(function (elemento) {

        renglon = elemento.split('\t')
        fecha = renglon[0].split('/')
        fecha = new Date(fecha[2] + '/' + fecha[1] + '/' + fecha[0])

        datos[indice] = ({
          'fecha': fecha,
          'transaccion': renglon[1],
          'cargo': renglon[3] !== '-' ? renglon[3] : '',
          'abono': renglon[2] !== '-' ? renglon[2] : '',
          'saldo': renglon[2] !== '-' ? renglon[2] : renglon[3],
          'notas': renglon[1],
        })

        indice = indice + 1
      })

      return datos

    } catch (e) {
      return false
    }
  }

  function arreglarDatosBanorte(data) {
    try {
      // Este script esta heco solo para Banorte
      let array = data.split('\n'),
        datos = [],
        renglon,
        fecha,
        fechaOperacion,
        cargo,
        abono,
        saldo,
        indice = 0
      array.forEach(function (elemento) {

        renglon = elemento.split('\t')
        datos[indice] = renglon
        fecha = renglon[1].split('/')
        fecha = new Date(fecha[2] + '/' + fecha[1] + '/' + fecha[0])

        fechaOperacion = renglon[0].split('/')
        fechaOperacion = new Date(fechaOperacion[2] + '/' + fechaOperacion[1] + '/' + fechaOperacion[0])

        cargo = renglon[7]
        abono = renglon[6]
        saldo = renglon[8]

        datos[indice] = ({
          'fecha': fecha,
          'fechaOperacion': fechaOperacion,
          'transaccion': renglon[10] ? renglon[10] : '',
          'cargo': cargo !== '' ? cargo : '',
          'abono': abono !== '' ? abono : '',
          'saldo': saldo !== '' ? saldo : '',
          'notas': renglon[3],
        })

        indice = indice + 1
      })

      return datos

    } catch (e) {
      return false
    }
  }

  function arreglarDatosBanBanjio(data) {
    try {
      // Este script esta heco solo para BanBanjio
      let array = data.split('\n'),
        datos = [],
        renglon,
        indice = 0,
        cargo,
        abono,
        aux
      array.forEach(function (elemento) {
        renglon = elemento.split('\t')

        aux = parseFloat(renglon[5])
        if (aux <= 0) {
          cargo = renglon[5]
          abono = ''
        } else {
          cargo = ''
          abono = renglon[5]
        }

        if (renglon[0] !== '') {
          if (datos.length > 0) {
            indice = datos.length
          }
          datos.push({
            'fecha': formarFechaBanBanjio(renglon[0]),
            'transaccion': renglon[1],
            'cargo': cargo,
            'abono': abono,
            'saldo': renglon[6],
            'notas': '',
          })

          if (renglon[2] !== 'No Aplica' && renglon[3] !== 'No Aplica' && renglon[4] !== 'No Aplica' && renglon[5] !== 'No Aplica') {
            datos[datos.length - 1].cargo = renglon[2]

            datos.push({
              'fecha': formarFechaBanBanjio(renglon[0]),
              'transaccion': renglon[1],
              'cargo': renglon[3],
              'abono': '',
              'saldo': renglon[6],
              'notas': 'COMISION POR ENVIO SPEI ',
            })

            datos.push({
              'fecha': formarFechaBanBanjio(renglon[0]),
              'transaccion': renglon[1],
              'cargo': renglon[4],
              'abono': '',
              'saldo': renglon[6],
              'notas': 'IVA COMISION POR ENVIO SPEI ',
            })
          }

        } else {

          datos[indice].notas += renglon[1] + ' '
          if (datos[indice + 1] && datos[indice + 2]) {
            datos[indice + 1].notas += renglon[1] + ' '
            datos[indice + 2].notas += renglon[1] + ' '
          }
        }
      })

      return datos

    } catch (e) {
      return false
    }
  }

  function arreglarDatosBanamex2(data) {
    try {

      // Este script esta heco solo para Bancomer
      let array = data.split('\n'),
        datos = [],
        renglon,
        fecha,
        indice = 0

      array.forEach(function (elemento) {
        renglon = elemento.split('\t')
        if (renglon[0] !== '') {

          fecha = renglon[0].split('/')

          fecha = new Date(fecha[2] + '/' + fecha[1] + '/' + fecha[0])

          datos[indice] = ({
            'fecha': fecha,
            'transaccion': renglon[1],
            'cargo': renglon[3] !== '-' ? renglon[3] : '',
            'abono': renglon[2] !== '-' ? renglon[2] : '',
            'saldo': renglon[4],
            'notas': '',
          })
        } else {
          indice = indice - 1
          datos[indice].notas += renglon[1] + ' '
        }
        indice = indice + 1
      })

      return datos
    } catch (e) {
      return false
    }
  }

  function arreglarDatosSantander(data) {
    try {
      // Este script esta heco solo para BanBanjio
      let array = data.split('\n'),
        datos = [],
        renglon,
        indice = 0,
        fecha
      array.forEach(function (elemento) {
        renglon = elemento.split('\t')
          .map(function (item) {
            return item.replace(/"/g, '')
          })
        if (renglon[3] === '') {
          throw 'Error al generar tabla'
        }
        fecha = new Date(renglon[1].substring(4, 8) + '/' + renglon[1].substring(2, 4) + '/' + renglon[1].substring(0, 2))

        datos[indice] = ({
          'fecha': fecha,
          'transaccion': renglon[7],
          'cargo': renglon[9] === '-' ? renglon[10] : '',
          'abono': renglon[9] === '+' ? renglon[10] : '',
          'saldo': renglon[11],
          'notas': renglon[7] + ' ' + (renglon[15] || ''),
          'referencia': renglon[13],
        })

        indice = indice + 1
      })
      return datos

    } catch (e) {
      return false
    }
  }

  function arreglarDatosSantanderSegundo(data) {
    try {
      // Este script esta heco solo para BanBanjio
      let array = data.split('\n'),
        datos = [],
        renglon,
        indice = 0,
        fecha
      array.forEach(function (elemento) {
        renglon = elemento.split('\t')
          .map(function (item) {
            return item.replace(/"/g, '')
          })

        if (renglon[4] === '') {
          throw 'Error al generar tabla'
        }
        fecha = new Date(renglon[1].substring(4, 8) + '/' + renglon[1].substring(2, 4) + '/' + renglon[1].substring(0, 2))

        datos[indice] = ({
          'fecha': fecha,
          'transaccion': renglon[10],
          'cargo': renglon[13] === '-' ? renglon[15] : '',
          'abono': renglon[13] === '+' ? renglon[15] : '',
          'saldo': renglon[16],
          'notas': renglon[10] + ' ' + renglon[20],
          'referencia': renglon[18],
          'concepto': renglon[21],
        })

        indice = indice + 1
      })

      return datos

    } catch (e) {
      return false
    }
  }

  function arreglarDatosScotiabank(data) {
    try {
      // Este script esta heco solo para BanBanjio
      let array = data.split('\n'),
        datos = [],
        renglon,
        indice = 0,
        fecha

      array.forEach(function (elemento) {
        renglon = elemento.split('|')
          .map(function (item) {
            return item.replace(/"/g, '')
          })
        fecha = new Date(renglon[4].replace(/\//g, '-'))
        datos[indice] = ({
          'fecha': fecha,
          'transaccion': renglon[1],
          'cargo': renglon[7].toLowerCase() === 'cargo' ? renglon[6] : '',
          'abono': renglon[7].toLowerCase() === 'abono' ? renglon[6] : '',
          'saldo': renglon[8],
          'notas': (renglon[1] + ' ' + renglon[10] + ' ' + renglon[9] + ' ' + renglon[13]).trim(),
          'referencia': renglon[5],
        })

        indice = indice + 1
      })

      return datos

    } catch (e) {
      return false
    }
  }

  function arreglarDatosBanRegio(data) {
    try {
      // Este script esta hecho solo para BanRegio
      let array = data.split('\n')
      let datos = []
      let renglon
      let fecha
      let comision

      array.forEach(function (elemento, index) {
        renglon = elemento.split('\t').map(function (item) {
          return item.replace(/"/g, '')
        })

        fecha = renglon[0].split('/')
        fecha = new Date(fecha[2] + '/' + fecha[1] + '/' + fecha[0])
        comision = renglon[1].toUpperCase().includes('COMISI') ? 'COMISION' : ''

        datos[index] = ({
          'fecha': fecha,
          'transaccion': (renglon[6] ? renglon[6] : '') + ' ' + comision,
          'cargo': renglon[3],
          'abono': renglon[4],
          'saldo': renglon[5],
          'notas': renglon[1],
          'referencia': renglon[2].slice(1),
        })
      })

      return datos
    } catch (e) {
      console.error('error', e)
      return false
    }
  }

  function getOperadoras() {
    return $http.get('/kendu/finanzas/cargaMovimientosBancario/clientesCuentasBancarias')
  }
}

module.service('CargarMovimientosBancarios', CargarMovimientosBancariosService)



// WEBPACK FOOTER //
// ./src/finanzas/services/CargarMovimientosBancariosService.js